<template>
  <Card variant="secondary" size="medium">
    <View gap="md" direction="column">
      <Text variant="label-medium" color="secondary">Access request</Text>
      <View gap="sm" direction="column">
        <View gap="sm">
          <PropertyPhotoPreview :image-url="request.property.coverImage ?? undefined" size="sm" />

          <View justify="center" direction="column">
            <Text variant="h5">{{ request.property.displayName }}</Text>
            <Text variant="label-medium" color="secondary">{{ requesterName }} asked to work on it</Text>
          </View>
        </View>

        <View gap="md" justify="space-between" align="end">
          <Text variant="body-small" color="secondary">Asked {{ askedAgo }}</Text>
          <Button variant="primary" size="medium" :to="propertyTeamRoute(request.property.id)">Review</Button>
        </View>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { useTimeAgo } from '@vueuse/core';
import { computed } from 'vue';

import { Button, Card, Text, View } from '@tallo/design-system';
import { teamMemberName } from '@tallo/investor/company';
import { propertyTeamRoute } from '@tallo/investor/navigation';
import { PropertyPhotoPreview } from '@tallo/property';

import { AccessRequestToAnswerDto } from '../../dtos/property-team.dto.interface';

/** A colleague waiting to work on a unit the viewer may add them to; Review opens the unit's Team tab. */
const props = defineProps<{ request: AccessRequestToAnswerDto }>();

const requesterName = computed(() => teamMemberName(props.request.requester));
const askedAgo = useTimeAgo(() => props.request.createdAt);
</script>
